export default "__VITE_ASSET__DcEtm0ij__"